import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  template: `
    <section id="left-content">
      <div style="height:100%;display:flex;align-items:center;justify-content:center;background-color:#ccc">List</div>
    </section>
    <section id="right-content">
      <section id="schedule-panel">
          <router-outlet></router-outlet>
      </section>
      <section id="map-panel">
          <div style="height:100%;display:flex;align-items:center;justify-content:center;background-color:#bfbfbf">Map</div>
      </section>
    </section>
  `,
  styles: [`
    :host {
      display: -ms-flexbox;
      display: flex;
      -ms-flex: 1 1 0px;
      flex: 1 1 0px;
    }
    #left-content {
      -ms-flex: 0 0 300px;
      flex: 0 0 300px;
    }
    #right-content {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex: 1 1 0px;
      flex: 1 1 0px;
      height: 100%;
      min-width: 0;
    }
    #schedule-panel {
      -ms-flex: 1 1 66%;
      flex: 1 1 66%;
      min-height: 400px;
    }
    #map-panel {
      -ms-flex: 1 1 33%;
      flex: 1 1 33%;
    }
  `]
})
export class MainComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/main.component.ts